import { render, staticRenderFns } from "./ShareFooter.vue?vue&type=template&id=4c7742bb"
import script from "./ShareFooter.vue?vue&type=script&lang=js"
export * from "./ShareFooter.vue?vue&type=script&lang=js"
import style0 from "./ShareFooter.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports